import React, { useState } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../redux/actions/purchasingHistory';

import style from './purchasingHistory.module.scss';
import SearchImage from '../../../assets/images/Search.svg';
import api from '../../../helpers/api';
import { IPurchase } from '../../../redux/reducers/purchasingHistory';
import { works } from '../Works';

import { validateInn, validateKpp } from './validation';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

interface IProps {
  setPurchasingHistory: (payload: IPurchase[]) => void;
  setPurchaseHistoryComplaints: (payload: any) => void;
  setPurchaseHistoryContractsAggregates: (payload: any) => void;
  setPurchasingHistoryLoading: Function;
  setPurchasingHistorySetInn: Function;
  setPurchasingHistorySetErrors: Function;
}

const PurchasingHistorySearch = ({
  setPurchasingHistory,
  setPurchasingHistoryLoading,
  setPurchasingHistorySetInn,
  setPurchasingHistorySetErrors,
  setPurchaseHistoryComplaints,
  setPurchaseHistoryContractsAggregates,
}: IProps) => {
  const [innValue, setInnValue] = useState('');
  const [kppValue, setKppValue] = useState('');
  const [isInnError, setInnError] = useState({ isError: false, errorMessage: '', showError: true });
  const [isKppError, setKppError] = useState({ isError: false, errorMessage: '', showError: true });

  const handleClick = async () => {
    if (works) return;
    if (innValue.trim() === '') {
      setInnError({ isError: true, errorMessage: 'Введите ИНН', showError: true });
      return;
    }
    setInnError({ isError: false, errorMessage: '', showError: false });

    if (!validateInn(innValue)) {
      setInnError({ isError: true, errorMessage: 'Введите корректный ИНН', showError: true });
      return;
    }
    setInnError({ isError: false, errorMessage: '', showError: false });

    if (!validateKpp(kppValue)) {
      setKppError({ isError: true, errorMessage: 'Введите корректный КПП', showError: true });
      return;
    }
    setKppError({ isError: false, errorMessage: '', showError: false });

    try {
      await setPurchasingHistoryLoading(true);
      await setPurchasingHistorySetInn(innValue);

      // let res: any = '';
      //
      // const user = await fetch('/api/auth/me', {
      //   headers: {
      //     'Cache-Control' : 'no-cache, no-store, must-revalidate',
      //     Pragma: 'no-cache',
      //   },
      // });
      //
      // if (user.status < 300 && user.status >= 200){
      //   const result = await user.json();
      //   if (!result.ownerData.companyInn){
      //     result.ownerData.companyInn = '0000000000';
      //   }
      //   if (!result.ownerData.companyKpp){
      //     result.ownerData.companyKpp = '0000000000';
      //   }
      //   res = await api.getPurchaseHistory(innValue.trim(), kppValue.trim(), 1, result.ownerData.companyInn, result.ownerData.companyKpp);
      // } else {
      //   res = await api.getPurchaseHistory(innValue.trim(), kppValue.trim(), 1, '0000000000', '0000000000');
      // }

      const res = await api.getPurchaseHistory(innValue.trim(), kppValue.trim(), 1, 'history');

      const complaints = await api.getPurchaseHistoryComplaints(innValue.trim());
      const aggregates = await api.getPurchaseHistoryContractsAggregates(innValue.trim());

      await api.sendReport(api.API_BID_REPORT_TYPE, {
        ...{ inn: innValue, kpp: kppValue },
        ...getReferrerFrom(),
      });
      if (res.error === 'NOT_FOUND') {
        setPurchasingHistorySetErrors(res.error);
        await setPurchasingHistoryLoading(false);
        return;
      }
      await setPurchasingHistory(res);

      await setPurchaseHistoryComplaints(complaints);
      await setPurchaseHistoryContractsAggregates(aggregates);

      await setPurchasingHistoryLoading(false);
    } catch (error: any) {
      console.log('catch', error);
      setPurchasingHistorySetErrors(error.message);
      await setPurchasingHistoryLoading(false);
    }
  };

  return (
    <div className={style.searchContainer}>
      <h3 className={style.title}>Введите ИНН или КПП организации</h3>
      <form className={style.form}>
        <div className={style.group}>
          <input
            type="text"
            placeholder="Введите ИНН..."
            className={style.searchInput}
            value={innValue}
            onChange={(event) => setInnValue(event.target.value)}
            onBlur={() => setInnError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (innValue.trim() !== '') setInnError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isInnError.isError && isInnError.showError && <div className={style.error}>{isInnError.errorMessage}</div>}
        </div>

        <div className={style.group}>
          <input
            type="text"
            placeholder="Введите КПП..."
            className={style.searchInput}
            value={kppValue}
            onChange={(event) => setKppValue(event.target.value)}
            onBlur={() => setKppError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (kppValue.trim() !== '') setKppError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isKppError.isError && isKppError.showError && <div className={style.error}>{isKppError.errorMessage}</div>}
        </div>

        <button
          type="submit"
          className={style.searchButton}
          onClick={(event) => {
            event.preventDefault();
            handleClick();
            setTimeout(() => {
              setInnError((prev) => ({ ...prev, showError: false }));
              setKppError((prev) => ({ ...prev, showError: false }));
            }, 5000);
          }}
        >
          <img src={SearchImage} alt="Поиск" className={style.searchImage} />
          Найти
        </button>
      </form>
    </div>
  );
};

export default connect(null, actions)(PurchasingHistorySearch);
